import {
  StyledConditionRow,
  StyledTitle,
  StyledDeleteButton,
  StyledTrashBin,
  StyledBooleanDropdownMenu,
  StyledColumnDropdownMenu,
  StyledOperatorDropdownMenu,
} from './filter-popover.styled';
import { ColumnDefinition, ConditionRow as ConditionRowType, OperatorDefinition, OperatorName } from './hooks';
import { ValueInputType } from './value-inputs/types';

const booleanOperatorDisplayToValue = (newValue: string): 'AND' | 'OR' => (newValue === 'and' ? 'AND' : 'OR');
const booleanOperatorValueToDisplay = (newValue: string): 'and' | 'or' => (newValue === 'AND' ? 'and' : 'or');

export const ConditionRow = <ColumnName extends string>({
  ValueInput,
  booleanOperator,
  columns,
  condition,
  fromHuman,
  handleChangeBooleanOperator,
  handleChangeColumn,
  handleChangeOperator,
  handleChangeValue,
  handleDeleteCondition,
  index,
  operators,
  toHuman,
}: {
  condition: ConditionRowType<ColumnName>;
  index: number;
  handleChangeBooleanOperator: (newValue: 'AND' | 'OR') => void;
  booleanOperator: 'AND' | 'OR';
  columns: readonly ColumnDefinition<ColumnName>[];
  handleChangeColumn: (id: string, newValue: ConditionRowType<ColumnName>['column']) => void;
  handleChangeOperator: (id: string, newValue: ConditionRowType<ColumnName>['operator']) => void;
  handleChangeValue: (id: string, newValue: ConditionRowType<ColumnName>['value']) => void;
  operators: readonly OperatorDefinition[];
  ValueInput: ValueInputType;
  handleDeleteCondition: (id: string) => void;
  toHuman: (filterValue: string | number | null) => string | number | null;
  fromHuman: (humanValue: string | number | null) => string | number | null;
}): React.ReactElement => (
  <StyledConditionRow gap={2}>
    {index === 0 ? (
      <StyledTitle fontWeight="medium" fontSize="sm">
        Where
      </StyledTitle>
    ) : index === 1 ? (
      <StyledBooleanDropdownMenu
        options={['and', 'or']}
        onChange={(booleanOperator: 'and' | 'or'): void =>
          handleChangeBooleanOperator(booleanOperatorDisplayToValue(booleanOperator))
        }
        value={booleanOperatorValueToDisplay(booleanOperator)}
      />
    ) : (
      <StyledTitle fontSize="sm">{booleanOperatorValueToDisplay(booleanOperator)}</StyledTitle>
    )}
    <StyledColumnDropdownMenu
      options={columns.map(({ label, name }) => ({ value: name, label }))}
      onChange={(column: ColumnName): void => handleChangeColumn(condition.id, column)}
      value={condition.column}
    />
    <StyledOperatorDropdownMenu
      options={operators.map(({ label, name }) => ({ value: name, label }))}
      onChange={(operator: OperatorName): void => handleChangeOperator(condition.id, operator)}
      value={condition.operator}
    />
    <ValueInput
      value={toHuman(condition.value)}
      onChange={(value): void => {
        handleChangeValue(condition.id, fromHuman(value));
      }}
      rowNumber={index}
    />
    <StyledDeleteButton
      onClick={(): void => handleDeleteCondition(condition.id)}
      size="base"
      variant="rsbry"
      rounded="regular"
    >
      <StyledTrashBin />
    </StyledDeleteButton>
  </StyledConditionRow>
);
